<template>
  <div>
    <b-container>
      WELCOME HOME :)
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'Home'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/home/Home.vue